// redux utils
import {createAsyncThunk} from '@reduxjs/toolkit';
// api
import * as ppa from './api/ppa'

export const PRODUCT_ARTICLE_SENTIMENT = 'ARTICLE_SENTIMENT';
export const PRODUCT_RATINGS = 'RATINGS';
export const PRODUCT_COMMENTING = 'COMMENTING';
export const PRODUCT_COMMENTING_V2 = 'COMMENTING_V2';
export const PRODUCT_REQUEST_PENDING = 'PENDING';
export const MIGRATION_STATUS_STARTED = 'STARTED';
export const PRODUCT_TRENDING_NOW = 'TRENDING_NOW';
export const PRODUCT_TRENDING_NOW_V2 = 'TRENDING_NOW_V2';
export const PRODUCT_ARTICLE_SENTIMENT_V2 = 'ARTICLE_SENTIMENT_V2'

// thunks
export const fetchAccountInfo = createAsyncThunk(
    'account/fetchAccountInfo',
    async accountUUID => {
    const response = await ppa.getAccountInfo(accountUUID);
    return response.data
});

export const fetchAccountSites = createAsyncThunk(
    'account/fetchAccountSites',
    async accountUUID => {
    const response = await ppa.getAccountSites(accountUUID);
    return response.data
});

export const fetchAccountSitesAndApps = createAsyncThunk(
    'account/fetchAccountSitesAndApps',
    async accountUUID => {
    const response = await ppa.getAccountSitesAndApps(accountUUID);
    return response.data
});

export const fetchInvoices = createAsyncThunk('account/fetchInvoices', async requestData => {
    const { accountUUID, year } = requestData;
    const response = await ppa.fetchInvoices(accountUUID, year);
    return response.data
})

export const fetchAccountProducts = createAsyncThunk(
    'account/fetchAccountProducts',
    async (accountUUID) => {
        const response = await ppa.getAccountProducts(accountUUID);
        return response.data
      });

export const fetchApprovedAccountProducts = createAsyncThunk(
  'account/fetcApprovedAccountProducts',
  async (accountUUID) => {
      const response = await ppa.getAccountProductsStatus({ accountUUID, status: 'APPROVED' });
      return response.data
  });

export const fetchPendingAccountProducts = createAsyncThunk(
  'account/fetchPendingAccountProducts',
  async (accountUUID) => {
      const response = await ppa.getAccountProductsStatus({ accountUUID, status: 'PENDING' });
      return response.data
  });

export const fetchRejectedAccountProducts = createAsyncThunk(
  'account/fetchRejectedAccountProducts',
  async (accountUUID) => {
      const response = await ppa.getAccountProductsStatus({ accountUUID, status: 'REJECTED' });
      return response.data
  });
  
  
  
export const fetchAccountSettings = createAsyncThunk('account/fetchAccountSettings', async accountUUID => {
    const response = await ppa.getAccountSettings(accountUUID);
    return response.data
})

export const updateAccountSettings = createAsyncThunk('account/updateAccountSettings', async (payload) => {
    const response = await ppa.updateAccountSettings(payload);
    return response.data
})

export const fetchAccountUsers = createAsyncThunk('account/fetchAccountUsers', async accountUUID => {
    const response = await ppa.getAccountUsers(accountUUID);
    return response.data
})

export const fetchInvoice = createAsyncThunk('account/fetchInvoice', async requestData => {
    const { accountUUID, date } = requestData
    const response = await ppa.fetchInvoice(accountUUID, date)
    return response.data
})

export const updateAccountDetails = createAsyncThunk('account/updateAccountDetails', async requestData => {
    const { accountUUID, cachedCompanyInfo } = requestData
    const response = await ppa.updateAccountInfo(accountUUID, cachedCompanyInfo)
    return response.data
})

export const fetchAccountCommentingRoles = createAsyncThunk('account/fetchAccountCommentingRoles', async accountUUID => {
    const response = await ppa.getAccountCommentingRoles(accountUUID)
    return response.data
})

export const checkCommentingEmailIfExist = createAsyncThunk('account/checkCommentingEmailIfExist', async email => {
    const response = await ppa.checkCommentingEmailIfExist(email)
    return {
        email,
        isExist: response.data
    }
})


export const fetchHistoricalData = createAsyncThunk('account/fetchHistoricalData', async accountUUID => {
    const response = await ppa.getHistoricalData(accountUUID)
    return response.data
})
export const setCommentingAccountStatus = createAsyncThunk('account/setCommentingAccountStatus', async requestData => {
    const { userUUID, isDeactivated } = requestData
    const response = await ppa.setCommentingAccountStatus(userUUID, isDeactivated)
    return {
        userUUID,
        deactivated: isDeactivated
    }
})

export const fetchPaymentInformation = createAsyncThunk('account/fetchPaymentInformation', async accountUUID => {
  const response = await ppa.getPaymentInformation(accountUUID)
  return response.data
})

export const fetchPaypalInformation = createAsyncThunk('account/fetchPaypalInformation', async paymentUUID => {
  const response = await ppa.getPayPalInformation(paymentUUID)
  return response.data
})

export const fetchACHInformation = createAsyncThunk('account/fetchACHInformation', async paymentUUID => {
  const response = await ppa.getACHInformation(paymentUUID)
  return response.data
})

export const fetchCheckInformation = createAsyncThunk('account/fetchCheckInformation', async paymentUUID => {
  const response = await ppa.getCheckInformation(paymentUUID)
  return response.data
})

export const fetchWireTransferInformation = createAsyncThunk('account/fetchWireTransferInformation', async paymentUUID => {
  const response = await ppa.getWireTransferInformation(paymentUUID)
  return response.data
})

const formatPaymentInfoData = (data, paymentType) => {
  // Send form data when other payment method is selectetd than paypal
  const formData = new FormData()
  const isFormData = paymentType !== 'PAYPAL'
  if(isFormData)  {
    Object.keys(data).forEach(key => {
      if(key === 'w9Form') formData.append(key, data[key], data['w9FormName']) // w9Form for ACH/Direct Deposit 
      else if(key === 'w8Form') formData.append(key, data[key], data['w8FormName']) // Wire Transfer w8 BEN/BENE Forms
      // else append all data 
      else formData.append(key, data[key])
    })
  }

  // Remove unnecessary form request data
  if(paymentType === 'WIRE') {
    formData.delete('w8BENFormLink')
    formData.delete('w8BENFormName')
    formData.delete('w8BENFormUpdateDateTime')

    formData.delete('w8BENEFormLink')
    formData.delete('w8BENEFormName')
    formData.delete('w8BENEFormUpdateDateTime')
  }

  return isFormData ? formData : data
}

export const createPaymentInformation = createAsyncThunk('account/createPaymentInformation', async requestData => {
  const { data, paymentType, accountUUID } = requestData
  const paymentInfoData = formatPaymentInfoData(data, paymentType)
  const response = await ppa.createPaymentInformation(paymentInfoData, paymentType, accountUUID)
  return response.data
})

export const updatePaymentInformation = createAsyncThunk('account/updatePaymentInformation', async requestData => {
  const { data, paymentType, paymentUUID } = requestData
  const paymentInfoData = formatPaymentInfoData(data, paymentType)
  const response = await ppa.updatePaymentInformation(paymentInfoData, paymentType, paymentUUID)
  return response.data
})

export const updateDisplayInvoice = createAsyncThunk('account/updateDisplayInvoice', async requestData => {
    const response = await ppa.updateDisplayInvoice(requestData)
    return response.data ;
})

export const updateApiAccess = createAsyncThunk('account/updateEnableApiAccess', async requestData => {
    const response = await ppa.updateApiAccess(requestData)
    return response.data ;
})